import { datadogRum, RumInitConfiguration } from '@datadog/browser-rum';
import { isRumEnabled } from './constants/environments';

export const configureDataDog = () => {
  const { hostname } = window.location;
  const hostnameEnvMap: Record<string, string> = {
    // eslint-disable-next-line @typescript-eslint/naming-convention
    'uat-arbor.trellisrx.com': 'uat',
    // eslint-disable-next-line @typescript-eslint/naming-convention
    'staging-arbor.trellisrx.com': 'staging',
    // eslint-disable-next-line @typescript-eslint/naming-convention
    'arbor.trellisrx.com': 'prod',
  };
  const env = hostnameEnvMap[hostname];

  // Check if RUM should be enabled for this environment
  if (!isRumEnabled(env)) {
    console.info(`[Datadog] RUM disabled for environment: ${env || 'unknown'}`);
    return;
  }

  const defaultOptions: Partial<RumInitConfiguration> & { enableSessionReplayRecording: boolean } =
    {
      sessionSampleRate: 100,
      sessionReplaySampleRate: 100,
      trackUserInteractions: true,
      trackResources: true,
      trackLongTasks: true,
      defaultPrivacyLevel: 'mask',
      enableSessionReplayRecording: true,
    };
  const envOptions: Record<
    string,
    Partial<RumInitConfiguration> & { enableSessionReplayRecording: boolean }
  > = {
    uat: {
      ...defaultOptions,
      defaultPrivacyLevel: 'allow',
    },
  };

  if (env) {
    const { enableSessionReplayRecording, ...options } = envOptions[env] || defaultOptions;
    datadogRum.init({
      applicationId: '<DD_APPLICATION_ID>',
      clientToken: '<DD_CLIENT_TOKEN>',
      site: 'datadoghq.com',
      service: 'tcms-ui',
      env,
      version: '9be05a0be3906668d81186354d3c2481aad379cc',
      allowedTracingUrls: [/^https:\/\/.*\.trellisrx\.com$/],
      ...options,
    });

    if (enableSessionReplayRecording) {
      datadogRum.startSessionReplayRecording();
    }
  }
};
